import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { LIBRARY_FEATURE_KEY } from './keys';
import { LibraryEffects } from './effects/library.effects';
import { libraryReducer } from './reducers/library.reducer';

@NgModule({
    imports: [CommonModule, StoreModule.forFeature(LIBRARY_FEATURE_KEY, libraryReducer), EffectsModule.forFeature([LibraryEffects])],
})
export class LibraryStoreModule {}
